import { InputAction, InputElement, InputMultiple, InputOptional, InputPageForward, InputSingleValueNumber, InputSingleValueString, InputValueBoolean } from "./Element";

export class Page {
    id: number | string = 0;
    name: string = "";
    label: string = "";
    url: string = "";
    isSelected: boolean = false;
    showOverview?: boolean = false;
    category?: string = "";
    elements: (InputElement | InputOptional | InputMultiple | InputAction |InputValueBoolean | InputSingleValueNumber | InputSingleValueString | InputPageForward)[] = []; 
    onPageLoad: () => boolean | void = () => { return true };
    isValid: () => { res: boolean, msg: string } = () => { return {res: true, msg: "" } };
    nextResolver: () => string =  () => { return (this.name + ": nextResolver missing !")};
 
    constructor(obj?: Partial<Page>) {
        Object.assign(this, obj);
    }
    
    
    /*
    constructor(p: page = {} as page)
    constructor(name: string, url: string)
    constructor(name: string, url: string, nextResolver: () => string)
    constructor(name: string, url: string, elements?: element[]) {
        this.name = p.name;
        this.url = p.url;
        this.isSelected = false;
        this.elements = p.elements || [];
        this.nextResolver = p.nextResolver || (() => {return "nextResolver missing !")};
    }
    */

}
